import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { valdiatePage } from "../../global";
import { getSubAccountLocations } from "../../services/userservice";
import { getLoadsheets, getLoadsheetCNs } from "../../services/loadsheetservice";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../redux/appSlice";
import { setData, updateData as updateD, resetData, setLocations, setGrid, setSelectedLocations } from "../../redux/seachLoadSheetSlice";
import ExportExcelButton from "../../components/exportExcelButton"; 

export const exportDetailsColumns = [
  { label: "Consignment No", key: "cn" },
  { label: "Customer Ref No", key: "refNo" },
  { label: "Booking Date", key: "bookingDate" },
  { label: "COD Amount", key: "codAmount" },
  { label: "Destination", key: "destination" },
  { label: "Service Type", key: "serviceType" },
  { label: "Weight", key: "weight" },
  { label: "Pieces", key: "pcs" },
];

const ExportDetails = ({ index, data, resetExportData }) => {
  useEffect(() => {
    resetExportData(index);
  }, [index, resetExportData]);

  return (
    <ExportExcelButton
      data={data}
      columns={exportDetailsColumns}
      fileName={`Loadsheet_${index + 1}`}
      
     
    />
  );
};

const RetailSearchLoadsheet = () => {

    const dispatch = useDispatch();

    const { appData, searchLoadSheetData } = useSelector(state => {
        return {
            appData: state.appData,
            searchLoadSheetData: state.searchLoadSheetData
        }
    });

    const { loading, userInfo, subaccounts } = appData;
    const { data, locations, grid, selectedLocations } = searchLoadSheetData;

    const history = useHistory();

    useEffect(() => {
    if (!valdiatePage("/searchloadsheets")) {
      history.push("/login");
    }

    return () => {
      dispatch(resetData({}));
      dispatch(setGrid({ data: [] }));
      dispatch(setLocations({ data: [] }));
    };
  }, [dispatch, history]);

    const updateData = (key, val) => {
        dispatch(updateD({ key, val }))
    }

    const onSearch = async () => {
    if (!data.subAccountId) return alert("Select Sub Account");
    if (selectedLocations.length === 0) return alert("Select Location");
    if (!data.from) return alert("Select From Date");
    if (!data.to) return alert("Select To Date");
    if (Date.parse(data.from) > Date.parse(data.to))
      return alert("Invalid Date Selection");

    const payload = {
      locationId: 0,
      from: data.from,
      to: data.to,
      locations: selectedLocations,
    };

    dispatch(setLoading({ data: true }));
    const rs = await getLoadsheets(payload);
    dispatch(setLoading({ data: false }));

    if (rs && rs.ok) dispatch(setGrid({ data: rs.data }));
  };

 const onGenerate = async (id) => {
    dispatch(setLoading({ data: true }));
    const rs = await getLoadsheetCNs(id);
    dispatch(setLoading({ data: false }));

    if (rs && rs.ok) {
      const printData = {
        lid: id,
        customerName: userInfo.name,
        accountNo: data.accountNo,
        data: rs.data,
      };
      sessionStorage.setItem("retailloadsheetinfo", JSON.stringify(printData));
      window.open("/cplight/retailloadsheetinfo.html", "_blank");
    }
  };


 const exportData = async (id, index) => {
    dispatch(setLoading({ data: true }));
    const rs = await getLoadsheetCNs(id);
    dispatch(setLoading({ data: false }));

    if (rs && rs.ok) {
      const g = [...grid];
      g[index] = { ...g[index], details: rs.data };
      dispatch(setGrid({ data: g }));
    }
  };


  const resetExportData = async (index) => {
    const g = [...grid];
    g[index] = { ...g[index], details: null };
    dispatch(setGrid({ data: g }));
  };


  return (
    userInfo && (
      <section className="section">
        <div className="section-header">
          <h1>Retail Search Loadsheets</h1>
        </div>

        <div className="card" style={{ padding: 10 }}>
    
          <div className="row">
            <div className="col-lg-2">
              <label>Sub Account</label>
              <select
                className="form-select"
                value={data.subAccountId}
                onChange={async (e) => {
                  const val = e.target.value;
                  const accno =
                    e.target[e.target.selectedIndex].getAttribute("data-accno");
                  dispatch(
                    setData({
                      data: {
                        ...data,
                        subAccountId: val,
                        locationId: "",
                        accountNo: accno,
                      },
                    })
                  );
                  dispatch(setSelectedLocations({ data: [] }));
                  if (val) {
                    const locs = await getSubAccountLocations(userInfo.id, val);
                    if (locs) dispatch(setLocations({ data: locs }));
                  } else {
                    dispatch(setLocations({ data: [] }));
                  }
                }}
              >
                <option value="" data-accno="">
                  Select Sub Account
                </option>
                {subaccounts.map((x, i) => (
                  <option
                    key={i}
                    value={x.id}
                    data-accno={x.accountNo}
                  >
                    {x.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-lg-2">
              <label>Locations</label>
              <select
                className="form-select"
                value={selectedLocations}
                onChange={(e) => {
                  const values = Array.from(
                    e.target.selectedOptions,
                    (option) => option.value
                  );
                  dispatch(setSelectedLocations({ data: values }));
                }}
                multiple
              >
                {locations.map((x, i) => (
                  <option key={i} value={x.value}>
                    {x.text}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-lg-2">
              <label>Order From</label>
              <input
                type="date"
                className="form-control"
                value={data.from}
                onChange={(e) => updateData("from", e.target.value)}
              />
            </div>

            <div className="col-lg-2">
              <label>Order To</label>
              <input
                type="date"
                className="form-control"
                value={data.to}
                onChange={(e) => updateData("to", e.target.value)}
              />
            </div>

            <div className="col-lg-2">
              <button
                type="button"
                className="btn btn-primary"
                disabled={loading}
                onClick={onSearch}
                style={{ marginTop: 30 }}
              >
                Search
              </button>
            </div>
          </div>

          {grid.length > 0 && (
            <div className="row mt-2">
              <div className="col-12">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Loadsheet Id</th>
                      <th>Total CNs</th>
                      <th>Date</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {grid.map((x, index) => (
                      <tr key={index}>
                        <td>{x.loadsheetId}</td>
                        <td>{x.totalCNs}</td>
                        <td>{x.creationDate}</td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-sm btn-primary"
                            onClick={() => onGenerate(x.loadsheetId)}
                          >
                            Generate Loadsheet
                          </button>
                        </td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-sm btn-primary"
                            onClick={() => exportData(x.loadsheetId, index)}
                          >
                            Export
                          </button>

                          {x.details?.length > 0 && (
                            <ExportDetails
                              index={index}
                              data={x.details}
                              resetExportData={resetExportData}
                            />
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </section>
    )
  );
};

export default RetailSearchLoadsheet;